<template>
  <div id="app">
    <transition name="fade"
         mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
      <router-view/>
    </transition>
  </div>
</template>
<style lang="scss">
</style>
<script>
import { init, getLoggedInUser, watchUserData } from '@/firebaseService.js'
export default {
  name: 'App',
  data () {
    return {
      prevHeight: 0
    }
  },
  methods: {
    beforeLeave (element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter (element) {
      const { height } = getComputedStyle(element)
      element.style.height = this.prevHeight
      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter (element) {
      element.style.height = 'auto'
    }
  },
  created () {
    init()
    getLoggedInUser().then(user => {
      this.$store.commit('setUser', user)
      if (user) {
        watchUserData()
      }
    })
  }
}
</script>
